import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ImportState } from '../_reducers/import.reduces';

const getImportFeatureState = createFeatureSelector<ImportState>('import');

export const getImportColumnsLoading = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.isImportColumnLoading
);

export const getImportFieldsLoading = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.fieldsLoading
);
/**
 * Select imports by table
 */
export const getImports = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.import
);

/**
 * Select import fields
 */
export const getImportFields = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.fields
);

/**
 * Import Columns
 */
export const getImportColumns = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.importColumn
);

/**
 * Select operations
 */
export const getImportOperations = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.operations
);

/**
 * Select error
 */
export const getImportError = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.error
);

export const getImportNameStatus = createSelector(
  getImportFeatureState,
  (state: ImportState) => state.importNameStatus
);